import React, { useState } from 'react';
import PrimaryButton from '../../../frontend-common-libs/src/common/buttons';
import styles from './styles/fleet.module.scss';
import unreserveSelectedInstruments, {
  assignProtocolHandler,
  setEditReservationsMode
} from './ReservationButtonsOnClickHandlers';
import { SecondaryButton } from '../../../frontend-common-libs/src/components/common/buttons';

export type Props = {
  isError: boolean;
  selectedInstruments: string[];
  isLoading: boolean;
  clearSelection: () => void;
  editReservations: boolean;
  setEditReservations: React.Dispatch<React.SetStateAction<boolean>>;
  selectedProtocol: string;
  setSelectedProtocol: React.Dispatch<React.SetStateAction<string>>;
  reservationProtocol: string;
  setReservationProtocol: React.Dispatch<React.SetStateAction<string>>;
  selectedProtocolId: string;
};

type ButtonProps = {
  id: string;
  label: string;
  stylesClassName?: string;
  disabled?: boolean;
  onClickHandler?: (...args: Array<any>) => any;
};

export default function ReservationButtons(props: Readonly<Props>) {
  const [isDisabled, setIsDisabled] = useState<boolean>(false);

  const {
    isError,
    selectedInstruments,
    isLoading,
    clearSelection,
    editReservations,
    setEditReservations,
    selectedProtocol,
    setSelectedProtocol,
    reservationProtocol,
    setReservationProtocol,
    selectedProtocolId
  } = props;

  const createButton = (buttonProps: ButtonProps) => {
    return (
      <PrimaryButton
        id={buttonProps.id}
        className={buttonProps.stylesClassName}
        type="submit"
        isInProgress={isLoading}
        disabled={buttonProps.disabled}
        onClick={buttonProps.onClickHandler}
      >
        {buttonProps.label}
      </PrimaryButton>
    );
  };

  const disableButton = isError || selectedInstruments.length === 0 || isDisabled;

  const renderUnreserveButton = (): React.JSX.Element => {
    return createButton({
      id: 'unreserve-button',
      label: 'Unreserve',
      stylesClassName: styles.unreserveButton,
      disabled: disableButton,
      onClickHandler: () =>
        unreserveSelectedInstruments(selectedInstruments, clearSelection, reservationProtocol)
    });
  };

  const renderEditButton = (): React.JSX.Element => {
    return createButton({
      id: 'edit-button',
      label: 'Edit',
      stylesClassName: styles.editButton,
      disabled: disableButton,
      onClickHandler: () => {
        setEditReservationsMode(setEditReservations, true);
      }
    });
  };

  const renderEditReservationButtons = () => {
    const onCancel = () => {
      setSelectedProtocol('');
      setEditReservationsMode(setEditReservations, false);
    };
    const cancelButton = (
      <SecondaryButton
        type="button"
        id="cancel-button"
        className={styles.cancelButton}
        onClick={onCancel}
      >
        Cancel
      </SecondaryButton>
    );
    const saveButton = createButton({
      id: 'save-button',
      label: 'Save',
      stylesClassName: styles.saveButton,
      disabled: disableButton,
      onClickHandler: async () => {
        setIsDisabled(true);
        await assignProtocolHandler(
          selectedProtocol,
          selectedInstruments,
          reservationProtocol,
          setReservationProtocol,
          selectedProtocolId
        );
        setSelectedProtocol('');
        setEditReservationsMode(setEditReservations, false);
        setIsDisabled(false);
      }
    });
    return (
      <>
        {cancelButton}
        {saveButton}
      </>
    );
  };

  const renderButtons = (): React.JSX.Element => {
    if (editReservations) {
      return renderEditReservationButtons();
    }
    return (
      <>
        {renderUnreserveButton()} {renderEditButton()}
      </>
    );
  };

  return <div className={styles.buttonContainer}>{renderButtons()}</div>;
}
